// const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const BASE_URL = API_BASE_URL
  ? API_BASE_URL
  : "http://localhost:5121/api";

// declare global {
//   interface Window {
//     RUNTIME_CONFIG: {
//       API_BASE_URL: string;
//     };
//   }
// }

// const _runtimeUrl = window.RUNTIME_CONFIG?.API_BASE_URL;
// export const BASE_URL =
//   _runtimeUrl && !_runtimeUrl.startsWith("${")
//     ? _runtimeUrl
//     : "http://localhost:5121/api";
